import { useContext } from 'react';
import { ReduxStoreContext } from '../redux/ReduxProvider';

export function useDispatch() {
  const { store } = useContext(ReduxStoreContext);
  return store.dispatch;
}
